import { MIN_PASSWORD_LENGTH } from '../../shared/passwordPolicy.js';

export const MIN_PASSWORD_LENGTH_HINT =
  `At least ${MIN_PASSWORD_LENGTH} characters, with upper and lower case letters, ` +
  'a digit, and a symbol.';
